import { knbrProduct } from './kn-br-product.i18n';

export const en = {
  knbrProduct,
};
